import { useContext } from 'react'
import { CheckoutContext } from './CheckoutProvider'

export const useContextCheckout = () => {
  const context = useContext(CheckoutContext)
  if (!context) throw new Error('useContextCheckout must be used within a CheckoutProvider')
  return context
}
